/* home nova (nt-fx-g1): filtro da vitrine "toda a linha" e botao de tocar e pausar do video das novidades.
   o arquivo e pedido por mais de uma secao: cada elemento so e ligado uma vez (data-nt-fx-pronto). */
(function () {
  'use strict';

  var semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* filtro de categoria: esconde e mostra os cartoes no proprio lugar, sem navegar.
     sem js os chips nao fazem nada e todos os produtos continuam visiveis */
  function ligarProdutos(raiz) {
    (raiz || document).querySelectorAll('.s-produtos[data-nt-fx]').forEach(function (sec) {
      if (sec.hasAttribute('data-nt-fx-pronto')) return;
      sec.setAttribute('data-nt-fx-pronto', '');

      var chips = Array.prototype.slice.call(sec.querySelectorAll('[data-nt-fx-chip]'));
      var cartoes = sec.querySelectorAll('[data-nt-fx-card]');
      var trilho = sec.querySelector('[data-nt-fx-trilho]');
      var grade = trilho && trilho.querySelector('.s-produtos__grade');
      var aviso = sec.querySelector('[data-nt-fx-vazio]');
      if (!chips.length || !trilho) return;

      function avisar(vazio) {
        if (!aviso) return;
        aviso.textContent = '';
        if (!vazio) return;
        var cartao = document.createElement('div');
        cartao.className = 'fx-cartao s-produtos__vazio-cartao';
        var t = document.createElement('p');
        t.className = 's-produtos__vazio-t';
        t.textContent = aviso.getAttribute('data-titulo') || '';
        var s = document.createElement('p');
        s.className = 's-produtos__vazio-s';
        s.textContent = aviso.getAttribute('data-texto') || '';
        cartao.appendChild(t);
        if (s.textContent) cartao.appendChild(s);
        aviso.appendChild(cartao);
      }

      /* a vitrine fica do tamanho do que sobrou no filtro (pedido do dono: sem vao embaixo). a troca de altura
         anda numa transicao curta; o que esta acima dos chips nao muda, entao os chips ficam parados na tela
         e so o resto da pagina sobe ou desce */
      var caixaChips = sec.querySelector('.s-produtos__chips');
      var animacao = null;

      function alturaVitrine() {
        var h = trilho.hidden ? 0 : trilho.getBoundingClientRect().height;
        if (aviso) h += aviso.getBoundingClientRect().height;
        return h;
      }

      function pararAnimacao() {
        if (!animacao) return;
        clearTimeout(animacao.relogio);
        animacao.el.removeEventListener('transitionend', animacao.fim);
        animacao.el.classList.remove('s-produtos__muda');
        animacao.el.style.height = '';
        animacao = null;
      }

      function animarAltura(de) {
        var el = trilho.hidden ? aviso : trilho;
        if (!el) return;
        var para = el.getBoundingClientRect().height;
        if (semMovimento || Math.abs(para - de) < 2) return;
        el.style.height = de + 'px';
        el.classList.add('s-produtos__muda');
        el.getBoundingClientRect();
        el.style.height = para + 'px';
        var fim = function (e) {
          if (e && (e.target !== el || e.propertyName !== 'height')) return;
          pararAnimacao();
        };
        animacao = { el: el, fim: fim, relogio: setTimeout(fim, 700) };
        el.addEventListener('transitionend', fim);
      }

      function aplicar(chip, rolar, animar) {
        var topoChips = caixaChips ? caixaChips.getBoundingClientRect().top : 0;
        var de = alturaVitrine();
        pararAnimacao();
        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        var bruto = (chip.getAttribute('data-nt-match') || '').trim();
        var termos = bruto ? bruto.split(',').map(function (t) { return t.trim(); }).filter(Boolean) : [];
        var visiveis = 0;
        cartoes.forEach(function (cartao) {
          var palheiro = cartao.getAttribute('data-nt-terms') || '';
          var casa = termos.length === 0 || termos.some(function (t) { return palheiro.indexOf(t) !== -1; });
          cartao.hidden = !casa;
          if (casa) visiveis += 1;
        });
        trilho.hidden = visiveis === 0;
        if (grade) grade.scrollLeft = 0;
        avisar(visiveis === 0);
        if (animar) animarAltura(de);
        /* garantia: se o navegador mexeu na rolagem com a troca, os chips voltam ao mesmo lugar da tela */
        if (caixaChips && animar) {
          var desvio = caixaChips.getBoundingClientRect().top - topoChips;
          if (Math.abs(desvio) > 1) window.scrollBy(0, desvio);
        }
        if (rolar) sec.scrollIntoView({ behavior: semMovimento ? 'auto' : 'smooth', block: 'start' });
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () { aplicar(chip, false, true); });
      });

      /* o chip marcado como ativo no editor ja filtra ao abrir */
      var ativo = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0];
      if (ativo && (ativo.getAttribute('data-nt-match') || '').trim()) aplicar(ativo, false);

      /* categoria vinda da url (?categoria=apelido), como no menu de produtos */
      var pedido = null;
      try { pedido = new URLSearchParams(window.location.search).get('categoria'); } catch (e) { pedido = null; }
      if (!pedido) return;
      pedido = pedido.trim().toLowerCase();
      for (var i = 0; i < chips.length; i++) {
        if ((chips[i].getAttribute('data-nt-slug') || '').toLowerCase() === pedido) {
          aplicar(chips[i], true);
          break;
        }
      }
    });
  }

  /* video das novidades: quem baixa e toca na tela e o <nt-clip> (nt-sections.js). aqui fica so o botao,
     que sempre deixa pausar ou tocar; pausado por quem visita, o video nao volta a tocar sozinho ao rolar */
  function ligarVideos(raiz) {
    (raiz || document).querySelectorAll('[data-nt-fx-play]').forEach(function (botao) {
      if (botao.hasAttribute('data-nt-fx-pronto')) return;
      botao.setAttribute('data-nt-fx-pronto', '');
      var clip = botao.closest('nt-clip');
      var video = clip && clip.querySelector('video');
      if (!video) return;
      var pausadoPorQuemVisita = false;

      function marcar() {
        var tocando = !video.paused;
        botao.setAttribute('data-estado', tocando ? 'tocando' : 'parado');
        botao.setAttribute('aria-label', botao.getAttribute(tocando ? 'data-pausar' : 'data-tocar') || '');
      }

      video.addEventListener('play', function () {
        if (pausadoPorQuemVisita) video.pause();
        marcar();
      });
      video.addEventListener('playing', marcar);
      video.addEventListener('pause', marcar);

      botao.addEventListener('click', function () {
        if (video.paused) {
          pausadoPorQuemVisita = false;
          if (typeof clip.load === 'function') clip.load();
          else if (!video.getAttribute('src')) video.src = video.getAttribute('data-nt-clip-src') || '';
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          pausadoPorQuemVisita = true;
          video.pause();
        }
      });
      marcar();
    });
  }

  /* faixa de novidades: a velocidade do editor e em pixels por segundo na fita da frente do computador (letra de
     30px). a duracao sai da largura real do trilho medida em letras, entao no celular, com a letra menor, a fita anda
     na mesma proporcao. a de tras anda 1,47 vez mais em letras por segundo, como no conceito */
  function ligarFaixas(raiz) {
    (raiz || document).querySelectorAll('.s-faixa-novidades[data-velocidade]').forEach(function (palco) {
      if (palco.hasAttribute('data-nt-fx-pronto')) return;
      palco.setAttribute('data-nt-fx-pronto', '');
      function ajustar() {
        var letrasPorSeg = (Number(palco.getAttribute('data-velocidade')) || 52) / 30;
        [['.s-faixa-novidades__frente', 1], ['.s-faixa-novidades__tras', 1.47]].forEach(function (par) {
          var fita = palco.querySelector(par[0]);
          var trilho = fita && fita.querySelector('.fx-faixa__trilho');
          if (!trilho || !trilho.offsetWidth) return;
          var letra = parseFloat(window.getComputedStyle(fita).fontSize) || 16;
          fita.style.setProperty('--faixa-tempo', (trilho.offsetWidth / letra / (letrasPorSeg * par[1])).toFixed(2) + 's');
        });
      }
      ajustar();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustar);
      if ('ResizeObserver' in window) {
        var largura = 0;
        new ResizeObserver(function () {
          if (palco.offsetWidth === largura) return;
          largura = palco.offsetWidth;
          ajustar();
        }).observe(palco);
      }
    });
  }

  function ligar(raiz) {
    ligarProdutos(raiz);
    ligarVideos(raiz);
    ligarFaixas(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { ligar(document); });
  else ligar(document);
  document.addEventListener('shopify:section:load', function (e) { ligar(e.target); });
})();
